import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Input, Text } from "@fragments";
import { SendTimeExtensionRounded } from "@mui/icons-material";

export default function Interactions({ configRef }) {
    const { t } = useTranslation("groupModals");
    const [enabled, setEnabled] = useState(
        configRef.current?.interactions_enabled
    );

    function handleChange(value) {
        configRef.current.interactions_enabled = value;
        setEnabled(value);
    }

    return (
        <>
            <Text.h3
                value={t("manageGroup.interactions.title")}
                className="mt-5 mb-1"
                grow
                left={<SendTimeExtensionRounded />}
            />

            <Text.h5
                grow
                contrast={5}
                value={t("manageGroup.interactions.description")}
            />

            <Input.Switch
                value={enabled}
                onInput={handleChange}
                label={t("manageGroup.interactions.switchLabel")}
            />
        </>
    );
}
